import { render } from "./EstadoVazio.vue?vue&type=template&id=fb148b40&scoped=true&lang=pug"
import script from "./EstadoVazio.vue?vue&type=script&lang=js"
export * from "./EstadoVazio.vue?vue&type=script&lang=js"

import "./EstadoVazio.vue?vue&type=style&index=0&id=fb148b40&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb148b40"],['__file',"src/common/SmartTable/EstadoVazio.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "fb148b40"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fb148b40', __exports__)) {
    api.reload('fb148b40', __exports__)
  }
  
  module.hot.accept("./EstadoVazio.vue?vue&type=template&id=fb148b40&scoped=true&lang=pug", () => {
    api.rerender('fb148b40', render)
  })

}


export default __exports__